import { gql } from '@apollo/client';

export default gql`
  mutation deleteHritem($_id: String) {
    deleteHritem(_id: $_id) {
      ok
      message
      error
    }
  }
`;
